import script from "./DrawDisbursements.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawDisbursements.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/draw-disbursement-details.css?vue&type=style&index=0&id=8a12f13e&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a12f13e"]])

export default __exports__